import React from "react";
import styled from "styled-components";
import { z } from "zod";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { Backdrop, BackdropBackground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
import { BladeContent } from "../../../components/BladeContent";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle, BladeHeaderTitle } from "../../../components/BladeHeader";
import { CharacterMastheadBladeSchema } from "../../../schemas/blades/CharacterMasthead";
import { RichText } from "../../../components/RichText";
import { Icon } from "../../../components/Icon";
export const CharacterMastheadBladeContractSchema = CharacterMastheadBladeSchema.extend({
    type: z.literal("characterMasthead"),
});
const _CharacterMasthead = ({ backdrop, title, subtitle, role, difficulty, description, links, linksLabel, ...bladeProps }) => {
    return (React.createElement(Blade, { "data-testid": "CharacterMasthead", ...bladeProps },
        React.createElement(Backdrop, null,
            backdrop.background && (React.createElement(BackdropBackground, null,
                React.createElement(Media, { media: backdrop.background, autoPlay: true }))),
            React.createElement("div", { className: "backdrop-gradient" })),
        React.createElement(BladeContent, { width: "large" },
            React.createElement("div", { className: "blade-top-content" },
                React.createElement(BladeHeader, null,
                    subtitle && React.createElement(BladeHeaderSupertitle, null, subtitle),
                    React.createElement(BladeHeaderTitle, null, title),
                    description && (React.createElement(BladeHeaderBody, null,
                        React.createElement(RichText, { ...description })))),
                React.createElement("div", { className: "character-meta-container" },
                    role && (React.createElement("div", { className: "character-meta-box-wrapper roles", "data-testid": "roles" },
                        React.createElement("div", { className: "character-meta-box" },
                            React.createElement("div", { className: "role-icon-wrapper" }, role?.roles.map((role) => (React.createElement(Icon, { "data-testid": "role-icon", className: "role-icon", key: role.id, name: role.id })))),
                            React.createElement("div", { className: "meta-description" },
                                React.createElement("p", { "data-testid": "meta-title", className: "meta-title" }, role.label),
                                React.createElement("p", { "data-testid": "meta-details", className: "meta-details" }, role?.roles.map((role) => role.name).join(" / ")))))),
                    difficulty && (React.createElement("div", { className: "character-meta-box-wrapper difficulty", "data-testid": "difficulty" },
                        React.createElement("div", { className: "character-meta-box" },
                            React.createElement("div", { className: "role-icon-wrapper" },
                                React.createElement(Icon, { "data-testid": "difficulty-icon", className: "difficulty-icon", name: `difficulty-${difficulty.value}` })),
                            React.createElement("div", { className: "meta-description" },
                                React.createElement("p", { "data-testid": "meta-title", className: "meta-title" }, difficulty.label),
                                React.createElement("p", { "data-testid": "meta-details", className: "meta-details" }, difficulty.name))))))),
            links && (React.createElement("div", { "data-testid": "character-mastery", className: "content-footer" },
                linksLabel && (React.createElement("p", { "data-testid": "character-mastery-title", className: "character-mastery-title" }, linksLabel)),
                links.map((link) => {
                    return link.action?.type === "weblink" ? (React.createElement("a", { "data-testid": "character-mastery-link", className: "character-mastery-link", href: link.action.payload?.url }, link.title)) : null;
                }))))));
};
export const CharacterMasthead = styled(_CharacterMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=CharacterMasthead.js.map